export const descriptionDateFormat = 'MMMM YYYY';

export const overviewApiDateFormat = 'YYYY-MM-DDTHH:mm:ss';
